<div
  class="modal-body modal-body--flex modal-body--inner"
  [ngClass]="{ 'modal-body--tall': modalComponent.modalViewProperties.isButtonConflictPresent }"
>
  @if (modalComponent.modalViewProperties.changeType === 'phone model') {
    <div class="text-center" data-automation="confirmation-modal-message">
      @if (modalComponent.modalViewProperties.isButtonConflictPresent && !isCopyUdpButton) {
        <p>
          {{
            'tkey;phone.phone_button_layout_conflict_modal.main.phone_model'
              | translate: { change: modalComponent.modalViewProperties.proposedValue }
          }}
        </p>
      }
      @if (!modalComponent.modalViewProperties.isButtonConflictPresent && !isCopyUdpButton) {
        <p>
          {{
            'tkey;phone.phone_button_layout_conflict_modal.main.phone_model.without_preview'
              | translate: { change: modalComponent.modalViewProperties.proposedValue }
          }}
        </p>
      }
      @if (isCopyUdpButton) {
        <p
          [innerHTML]="'tkey;phone.phone_button_layout_conflict_modal.main.phone_model.copy_from_udp' | escapeHtml"
        ></p>
      }
    </div>
  }
  @if (isCopyUdpButton) {
    <div class="text-center" data-automation="confirmation-modal-message-tip">
      <p
        [innerHTML]="'tkey;phone.phone_button_layout_conflict_modal.main.phone_model.copy_from_udp.tip' | escapeHtml"
      ></p>
      <p
        [innerHTML]="
          'tkey;phone.phone_button_layout_conflict_modal.main.phone_model.copy_from_udp.warning' | escapeHtml
        "
        class="text-center text-warning"
        data-automation="phone-button-layout-conflict-modal-copy-udp-warning"
      ></p>
    </div>
  }
  @if (modalComponent.modalViewProperties.changeType === 'phone button template') {
    <p class="text-center" data-automation="confirmation-modal-message">
      {{
        'tkey;phone.phone_button_layout_conflict_modal.main.phone_button_template'
          | translate: { change: modalComponent.modalViewProperties.proposedValue }
      }}
    </p>
  }

  @if (
    modalComponent.modalViewProperties.currentExpansionModules?.length === 0 &&
    modalComponent.modalViewProperties.isButtonConflictPresent &&
    !isCopyUdpButton
  ) {
    <p class="text-center text-warning" data-automation="phone-button-layout-conflict-modal-warning">
      {{ 'tkey;phone.phone_button_layout_conflict_modal.warning.buttons' | translate }}
    </p>
  }
  @if (
    modalComponent.modalViewProperties.currentExpansionModules?.length > 0 &&
    !modalComponent.modalViewProperties.isButtonConflictPresent
  ) {
    <p class="text-center text-warning" data-automation="phone-button-layout-conflict-modal-warning">
      {{
        'tkey;phone.phone_button_layout_conflict_modal.warning.expansion_modules'
          | translate: { expansionModules: modalComponent.modalViewProperties.currentExpansionModules?.join(', ') }
      }}
    </p>
  }
  @if (
    modalComponent.modalViewProperties.currentExpansionModules?.length > 0 &&
    modalComponent.modalViewProperties.isButtonConflictPresent
  ) {
    <p class="text-center text-warning" data-automation="phone-button-layout-conflict-modal-warning">
      {{
        'tkey;phone.phone_button_layout_conflict_modal.warning.both'
          | translate: { expansionModules: modalComponent.modalViewProperties.currentExpansionModules?.join(', ') }
      }}
    </p>
  }

  @if (modalComponent.modalViewProperties.isButtonConflictPresent) {
    <div class="overflow-auto" id="scrollableButtonRowTable">
      <table class="table table--scrollable">
        <thead>
          <tr class="table--scrollable__header">
            <th class="table-col-1"></th>
            <th class="table-col-5" data-automation="phone-button-layout-conflict-modal-current-value">
              <strong>
                {{ modalComponent.modalViewProperties.currentValue }} ({{
                  !isCopyUdpButton
                    ? ('tkey;phone.phone_button_layout_conflict_modal.current' | translate)
                    : ('tkey;phone.phone_button_layout_conflict_modal.current.extension_mobility' | translate)
                }})
              </strong>
            </th>
            <th class="table-col-1"></th>
            <th class="table-col-5" data-automation="phone-button-layout-conflict-modal-new-value">
              <strong>
                {{ modalComponent.modalViewProperties.proposedValue }} ({{
                  !isCopyUdpButton
                    ? ('tkey;phone.phone_button_layout_conflict_modal.new' | translate)
                    : ('tkey;phone.phone_button_layout_conflict_modal.new.deskphone' | translate)
                }})
              </strong>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of buttonRows; track row; let i = $index) {
            <tr
              [ngClass]="{
                'table-warning':
                  (row.current.value && !row.proposed.value) || (row.current.label && !row.proposed.label),
              }"
              data-automation="phone-button-layout-conflict-modal-button-row"
            >
              <td class="table-cell">
                @if (row.current) {
                  <span>{{ i + 1 }}</span>
                }
              </td>
              <td class="table-cell">
                @if (row.current) {
                  <span>
                    <span data-automation="phone-button-layout-conflict-modal-current-type">
                      {{ row.current.type }}
                    </span>
                    <br />
                    <span data-automation="phone-button-layout-conflict-modal-current-description">
                      {{ row.current.value ? ' ' + row.current.value : ''
                      }}{{ row.current.label ? ' - ' + row.current.label : '' }}
                    </span>
                  </span>
                }
              </td>
              <td class="table-cell">
                @if (row.proposed) {
                  <span>{{ i + 1 }}</span>
                }
              </td>
              <td class="table-cell">
                @if (row.proposed) {
                  <span>
                    <span data-automation="phone-button-layout-conflict-modal-new-type">{{ row.proposed.type }}</span>
                    <br />
                    <span data-automation="phone-button-layout-conflict-modal-new-description">
                      {{ row.proposed.value ? ' ' + row.proposed.value : ''
                      }}{{ row.proposed.label ? ' - ' + row.proposed.label : '' }}
                    </span>
                  </span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
